var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('div',{staticClass:"pdf"},[_c('div',{staticClass:"pdf-head"},[_vm._v("Route Information "),_c('div',{staticClass:"pdf-close",on:{"click":_vm.onCloseClick}})]),_c('iframe',{staticClass:"pdf-iframe",attrs:{"src":_vm.src,"width":"100%","height":"100%"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }